import type { FC } from 'react';
import type { DateTimeGroupProps } from '../../types';

const DateTimeGroup: FC<DateTimeGroupProps> = ({
  dateValue,
  timeValue,
  onDateChange,
  onTimeChange,
}) => (
  <div className="schedule-meeting-modal__pill-box">
    <div className="schedule-meeting-modal__pill" style={{ position: 'relative' }}>
      <input
        className="schedule-meeting-modal__date-input"
        type="date"
        value={dateValue}
        onChange={(e) => onDateChange(e.target.value)}
      />
    </div>
    <div className="schedule-meeting-modal__pill" style={{ position: 'relative' }}>
      <input
        className="schedule-meeting-modal__time-input"
        type="time"
        value={timeValue}
        onChange={(e) => onTimeChange(e.target.value)}
      />
    </div>
  </div>
);

export default DateTimeGroup;
